export const IMPORT_FIELDS = ['firstName', 'lastName', 'email', 'phone', 'country', 'language', 'detail'];
export const IMPORT_DEFAULTS = { collectionSource: '', lawfulBasis: '', language: '', assignedTo: '', collectionContext: '' };
export const IMPORT_PAGE_SIZE = 100;
export const isImportActive = (status) => ['queued', 'running'].includes(status);

const aliases = {
  firstName: ['firstname', 'name', 'имя'], lastName: ['lastname', 'surname', 'фамилия'],
  email: ['email', 'emailaddress', 'почта', 'электроннаяпочта'],
  phone: ['phone', 'mobile', 'telephone', 'phonenumber', 'телефон', 'мобильный'],
  country: ['country', 'countrycode', 'страна'], language: ['language', 'язык'],
};
export function suggestMapping(columns) {
  const used = new Set();
  return columns.map(({ index, label }) => {
    const header = label.toLowerCase().replace(/[\s_\-.]+/g, '');
    const field = Object.keys(aliases).find((key) => !used.has(key) && aliases[key].includes(header)) || '';
    if (field) used.add(field);
    return { column: index, field, detailName: '' };
  });
}
export function buildImportPreview(sheet, mapping, defaults) {
  const selected = mapping.filter((item) => item.field);
  if (!selected.some(({ field }) => ['email', 'phone'].includes(field))) throw new Error('contactMappingRequired');
  if (!defaults.collectionSource || !defaults.lawfulBasis) throw new Error('defaultsRequired');
  const destinations = new Set();
  const cleanMapping = selected.map(({ column, field, detailName }) => {
    if (!IMPORT_FIELDS.includes(field)) throw new Error('invalidMapping');
    const name = String(detailName || '').trim();
    if (field === 'detail' && (!name || name.length > 128)) throw new Error('detailNameRequired');
    const destination = field === 'detail' ? `detail:${name.toLowerCase()}` : field;
    if (destinations.has(destination)) throw new Error('duplicateMapping');
    destinations.add(destination);
    return { column, field, ...(field === 'detail' ? { detailName: name } : {}) };
  });
  const cleanDefaults = Object.fromEntries(Object.keys(IMPORT_DEFAULTS)
    .map((key) => [key, String(defaults[key] || '').trim()]).filter(([, value]) => value));
  return { sheet, mapping: cleanMapping, defaults: cleanDefaults };
}
export function saveImportDownload({ blob, filename }) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const isImportDeletable = (status) => ['draft', 'preview', 'completed', 'failed'].includes(status);
